import clientConfigApi from '../config/config'
import axios from 'axios';
import { token, CMSPath } from '../config/constant';


export const fetchActivities = (actWid) => {
  let obj;
  if (actWid && actWid.length > 0) {
    actWid.map((iterator) => {
      if (iterator.widgetType === "Activities") {
        obj = iterator;
      }
    })
  }
  // console.log("actWid", obj);
  //let actData = {}
  return async dispatch => {
    try {
      if (obj.widgetType === "Activities") {
        clientConfigApi.post(
          "/fetchActivityGroupDetails",
          {
            "header": {
              "activityGroupId": obj.activityGroupSku
            },
            "payload": {}
          }
        )
          .then((actData) => {
            // console.log("act data", actData);
            if (actData && actData.data && actData.data.payload) {
              dispatch({
                type: 'Set_Activities',
                payload: actData.data.payload
              })
            }
          })
          .catch(
            ({ response = {} }) => {
              console.log("Api failed with the status that's worng code:", response.status, actWid[0].activityGroupSku)
            }
          )
      }
    } catch (e) {
      console.log("error in fetching activity", e);
    }
  }
}

export const setCurrentActivity = (activity, nextActivity) => {
  /*let currentIndex;
  activities.map((iterator, index) => {
    if (iterator.name === currentActivity.name) {
      currentIndex = index;
    }
    return 0;
  })
  if (activities[currentIndex + 1]) {
    this.props.setCurrentActivity(activities[currentIndex + 1])
  } else {
    this.props.setCurrentActivity(activities[0])
  }*/
  return {
    type: 'Set_Current_Activity',
    payload: {
      currentActivity: activity,
      nextActivity
    }
  }
}

//initial signup activity
export const setSignUpActivities = (signUpList) => {
  return {
    type: 'Set_signUp_Activities',
    payload: signUpList
  }
}

//adding to signup activities
export const addToSignUp = (addItem) => {
  return {
    type: 'Add_To_SignUp_Activities',
    payload: addItem
  }
}

export const signUpAct = (resNo, act, guestDetail, callBack) => {
  console.log("resNO", resNo);
  let sessionToken = localStorage.getItem("GuestJourneySessionToken");
  return async dispatch => {
    try {
      if (guestDetail.guestToken) {
        axios.post(
          `${CMSPath}/Connector/rest/activity/guestSignUp`,
          {
            "header": {
              "sessionToken": sessionToken,
              "guestToken": guestDetail.guestToken,
              "locationId": guestDetail.locationId,
              "loggedinGuestToken": guestDetail.guestToken

            },
            "payload": {
              "reservationNumber": resNo,
              "qualityPlusRequest": [{
                "activityId": act.activityId,
                "additionalNote": "none"
              }]
            }
          }
        )
          .then((res) => {
            //console.log("act data", act);
            if (res && res.data && res.data.header.status) {
              if (res.data.header.status.code === "SUCCESS" ||
                res.data.header.status.code === "success") {
                callBack(true);
              } else {
                callBack(false);
              }
            }
          })
          .catch(
            (response = {}) => {
              callBack(false)
              console.log("Api failed with the status that's worng code:", response)
            }
          )
      } else {
        console.log("there is no guest.")
      }
    } catch (e) {
      console.log("error in signing up activity", e);
      callBack(false);
    }
  }
}